import { FormControl, MenuItem, Select } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'

const SelectorChart = ({ path }) => {
  const navigate = useNavigate()
  const params = useParams()
  const chartType = params['*'].split('/')[0]

  const options = [
    { value: 'learning-matrix', label: 'Learning matrix' },
    // { value: 'learning-growth-column', label: 'Learning growth column'},
    { value: 'learning-growth', label: 'Learning growth' },
    // { value: 'curriculum-levels', label: 'Curriculum levels'},
    { value: 'by-unit-of-learning', label: 'By unit of learning' }
  ]
  const onChange = (e) => {
    let pathname = path
    if (chartType === '') {
      pathname = path
    } else if (chartType === 'learning-matrix') {
      pathname = path.replace('/learning-matrix', '')
    } else {
      pathname = path.split('/').slice(0, -1).join('/')
    }

    navigate(`${pathname}/${e.target.value}`)
  }

  return (
    <div className='py-1 px-2 max-w-150px min-w-150px absolute top-0px bottom-0px left-0px flex flex-col justify-center overflow-auto bg-primary'>
      <FormControl variant='outlined' className='max-w-150px min-w-150px bg-background rounded'>
        <Select
          variant='outlined'
          value={chartType === '' ? 'learning-matrix' : chartType}
          onChange={onChange}
          size='small'
        >
          {options?.map((op) => (
            <MenuItem key={`selector-chart-${op.value}`} value={op.value}>
              {op.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  )
}

export default SelectorChart
